import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  :root {
    --color-topbar-background: #ffffff;
    --color-menu-background: #8f8d94;
    --color-background: #f5f3fa;
    --color-font: #2e2733;

    --color-dark-grey: #707070;
    --color-medium-grey: #ababab;
    --color-light-grey: #fafafa;

    --color-white: #ffffff;
    --color-black: #000000;

    --color-primary: #5B1C4B;
    --color-green: #00B333;
    --color-blue: #19A6FF;
    --color-red: #C41104;
    --color-orange: #FFCE19;
  }
  * {
    box-sizing: border-box;
  }
  @font-face {
    font-family: 'Open Sans', sans-serif;
    src: local('OpenSans'), url(../fonts/OpenSans/OpenSans-Regular.ttf) format('truetype');
  }
  body {
    font-family: 'Open Sans', sans-serif;
    margin: 0;
    padding: 0;
    background-color: var(--color-background);
    color: var(--color-font);
    font-size: 16px;
  }
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
    color: var(--color-font);
  }
  h1 {
    font-size: 1.5em;
  }
  ul {
    margin: 0 !important;
    padding: 0;
  }
`
export default GlobalStyle
